module.exports = __webpack_public_path__ + "fonts/Raleway-Regular.b304ecae.woff2";